module.exports = __webpack_public_path__ + "static/media/Slide3.3bce679b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide3.png
// module id = 572
// module chunks = 4